<template>
  <base-dialog
    v-model="dialog.show"
    max-width="800px"
    min-width="300px"
    disabledAction
    scrollable
    title="Chi tiết dữ liệu"
    width="50%"
  >
    <ResultFeature :value="value" :fields="fields" class="mb-8" />
  </base-dialog>
</template>

<script>
import ResultFeature from '@components/search/result/result-feature.vue'
export default {
  components: { ResultFeature },
  // props: {
  //   fields: { type: Array, required: true },
  // },
  data() {
    return {
      fields: [],
      value: {},
      dialog: {
        show: false,
      },
    }
  },
  watch: {},
  computed: {},
  methods: {
    open({ data, fields } = {}) {
      this.fields = fields
      this.value = data
      this.dialog.show = true
    },
  },
}
</script>
